(function () {
  function initPackSelector(selector) {
    if (!selector || selector.dataset.packInitialized === 'true') {
      return;
    }

    const sectionId = selector.dataset.sectionId;

    if (!sectionId) {
      console.warn('[PACK] data-section-id manquant', selector);
      return;
    }

    const packs = Array.from(
      selector.querySelectorAll('.pack-card')
    );

    if (!packs.length) {
      return;
    }

    const productRoot =
      selector.closest('.product-info') ||
      selector.closest('[id^="x-product-template-"]') ||
      selector.closest('.shopify-section') ||
      document;

    const mainForm =
      productRoot.querySelector(
        'form[data-type="add-to-cart-form"]:not([id*="sticky"])'
      ) ||
      Array.from(
        document.querySelectorAll(
          'form[data-type="add-to-cart-form"]'
        )
      ).find(function (form) {
        return !String(form.id || '').includes('sticky');
      });

    if (!mainForm) {
      console.warn('[PACK] Formulaire principal introuvable');
      return;
    }

    selector.dataset.packInitialized = 'true';

    const mainButton = mainForm.querySelector(
      'button[name="add"]'
    );

    const mainAtcText = mainButton
      ? mainButton.querySelector('.x-atc-text, .button-text')
      : null;

    let mainQtyInput = mainForm.querySelector(
      'input[name="quantity"]'
    );

    if (!mainQtyInput) {
      mainQtyInput = document.createElement('input');
      mainQtyInput.type = 'hidden';
      mainQtyInput.name = 'quantity';
      mainQtyInput.value = '1';
      mainQtyInput.id = 'pack-quantity-' + sectionId;
      mainForm.appendChild(mainQtyInput);
    }

    let savingText = mainForm.querySelector(
      '.pack-atc-saving'
    );

    if (!savingText && mainButton) {
      savingText = document.createElement('div');
      savingText.className = 'pack-atc-saving';

      mainButton.insertAdjacentElement(
        'afterend',
        savingText
      );
    }

    function getStickyRoot() {
      return (
        document.getElementById(
          'sticky-add-to-cart-' + sectionId
        ) ||
        document.querySelector('.sticky_add_to_cart')
      );
    }

    function ensureStickyQtyInput(stickyRoot) {
      if (!stickyRoot) return null;

      const stickyForm = stickyRoot.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

      if (!stickyForm) return null;

      let input = stickyForm.querySelector(
        'input[name="quantity"]'
      );

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.value = '1';
        input.id =
          'pack-quantity-sticky-' + sectionId;

        stickyForm.appendChild(input);
      }

      return input;
    }

    function updateMainButton(price, compare) {
      if (!mainAtcText) return;

      mainAtcText.innerHTML = `
        <span class="flex items-center justify-center">
          <span>AJOUTER AU PANIER</span>

          <span class="pack-atc-prices">
            ${
              compare
                ? `<span class="pack-atc-compare">${compare}</span>`
                : ''
            }

            ${
              price
                ? `<span class="pack-atc-price">${price}</span>`
                : ''
            }
          </span>
        </span>
      `;
    }

    function updateStickyButton(price, compare) {
      const stickyRoot = getStickyRoot();

      if (!stickyRoot) {
        console.warn(
          '[PACK] Sticky introuvable pour la section',
          sectionId
        );
        return;
      }

      const buttonPriceContainers =
        stickyRoot.querySelectorAll(
          '.sticky-atc-button-price'
        );

      buttonPriceContainers.forEach(function (container) {
        const currentPrice =
          container.querySelector(
            '.sticky-atc-button-current-price .price'
          ) ||
          container.querySelector(
            '.sticky-atc-button-current-price'
          ) ||
          container.querySelector('.price');

        const comparePrice =
          container.querySelector(
            '.sticky-atc-button-compare-price'
          ) ||
          container.querySelector(
            '.product-offer-sticky-compare-price'
          );

        if (currentPrice) {
          currentPrice.textContent = price;
        }

        if (comparePrice) {
          comparePrice.textContent = compare;
          comparePrice.hidden = !compare;
          comparePrice.style.display = compare
            ? ''
            : 'none';
        }
      });

      /*
       * Met également à jour les éventuels prix
       * affichés à gauche dans le sticky.
       */
      const standardPriceAreas =
        stickyRoot.querySelectorAll(
          '.pricearea:not(.sticky-atc-button-price)'
        );

      standardPriceAreas.forEach(function (area) {
        const currentPriceTargets =
          area.querySelectorAll(
            'p.price > span, .price-sale, .price-item--sale'
          );

        currentPriceTargets.forEach(function (element) {
          element.textContent = price;
        });

        const compareTargets =
          area.querySelectorAll(
            '.price-compare, .price-item--regular, s'
          );

        compareTargets.forEach(function (element) {
          element.textContent = compare;
          element.style.display = compare
            ? ''
            : 'none';
        });
      });

      console.log(
        '[PACK] Prix sticky mis à jour :',
        price,
        compare,
        'conteneurs :',
        buttonPriceContainers.length
      );
    }

    function updateQuantity(quantity) {
      mainQtyInput.value = quantity;

      mainQtyInput.dispatchEvent(
        new Event('input', {
          bubbles: true
        })
      );

      mainQtyInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      const stickyRoot = getStickyRoot();

      if (!stickyRoot) return;

      const stickyQtyInput =
        ensureStickyQtyInput(stickyRoot);

      if (stickyQtyInput) {
        stickyQtyInput.value = quantity;

        stickyQtyInput.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );

        stickyQtyInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      const visibleStickyQty =
        stickyRoot.querySelector(
          '#Quantity-sticky-' + sectionId
        );

      if (visibleStickyQty) {
        visibleStickyQty.value = quantity;

        visibleStickyQty.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );

        visibleStickyQty.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      document.dispatchEvent(
        new CustomEvent(
          'eurus:product:quantity-changed-' +
            sectionId,
          {
            detail: {
              quantity: quantity
            }
          }
        )
      );
    }

    function updateStickyVariant() {
      const stickyRoot = getStickyRoot();

      if (!stickyRoot) return;

      const mainVariantInput =
        mainForm.querySelector(
          'input[name="id"]'
        );

      const stickyVariantInput =
        stickyRoot.querySelector(
          '#update-variant-sticky-' + sectionId
        );

      if (
        !mainVariantInput ||
        !stickyVariantInput
      ) {
        return;
      }

      stickyVariantInput.value =
        mainVariantInput.value;
    }

    function updateStickyTitle(title) {
      const stickyRoot = getStickyRoot();

      if (!stickyRoot || !title) return;

      stickyRoot
        .querySelectorAll(
          '.sticky-product-title'
        )
        .forEach(function (element) {
          element.textContent = title;
        });
    }

    function updateSaving(pack) {
      if (!savingText) return;

      const savingElement =
        pack.querySelector(
          '.pack-saving-text'
        );

      const saving = savingElement
        ? savingElement.textContent.trim()
        : '';

      savingText.textContent = saving;
      savingText.style.display = saving
        ? 'block'
        : 'none';
    }

    function applyPack(pack) {
      if (!pack) return;

      packs.forEach(function (item) {
        item.classList.toggle(
          'active',
          item === pack
        );
      });

      const quantity =
        pack.dataset.qty || '1';

      const price =
        pack.dataset.price || '';

      const compare =
        pack.dataset.compare || '';

      const title =
        pack.dataset.title || '';

      console.log('[PACK] Pack sélectionné :', {
        quantity: quantity,
        price: price,
        compare: compare,
        title: title
      });

      updateQuantity(quantity);
      updateMainButton(price, compare);
      updateStickyButton(price, compare);
      updateStickyVariant();
      updateStickyTitle(title);
      updateSaving(pack);

      /*
       * Sécurité : certains composants du thème
       * se mettent à jour après les événements quantity/change.
       */
      requestAnimationFrame(function () {
        updateStickyButton(price, compare);
      });

      window.setTimeout(function () {
        updateStickyButton(price, compare);
      }, 50);

      window.setTimeout(function () {
        updateStickyButton(price, compare);
      }, 150);
    }

    packs.forEach(function (pack) {
      pack.addEventListener('click', function () {
        applyPack(pack);
      });
    });

    const variantInput =
      mainForm.querySelector(
        'input[name="id"]'
      );

    if (variantInput) {
      variantInput.addEventListener(
        'change',
        function () {
          window.setTimeout(function () {
            const activePack =
              selector.querySelector(
                '.pack-card.active'
              ) || packs[0];

            applyPack(activePack);
          }, 100);
        }
      );
    }

    const initiallyActivePack =
      selector.querySelector(
        '.pack-card.active'
      ) || packs[0];

    applyPack(initiallyActivePack);
  }

  function initAllPackSelectors(scope) {
    const root = scope || document;

    root
      .querySelectorAll('.pack-selector')
      .forEach(initPackSelector);
  }

  function init() {
    initAllPackSelectors(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllPackSelectors(event.target);
    }
  );
})();